import Model from '../Model';
export default class Group extends Model {
  static ADMINISTRATOR_ID = '1';
  static GUEST_ID = '2';
  static MEMBER_ID = '3';
  nameSingular() {
    return Model.attribute('nameSingular').call(this);
  }
  namePlural() {
    return Model.attribute('namePlural').call(this);
  }
  color() {
    return Model.attribute('color').call(this);
  }
  icon() {
    return Model.attribute('icon').call(this);
  }
  isHidden() {
    return Model.attribute('isHidden').call(this);
  }
  position() {
    return Model.attribute('position').call(this);
  }
}
flarum.reg.add('core', 'common/models/Group', Group);